import { createContext, useCallback, useState } from 'react';

import { DefaultPlatformFilterType, PlatformFilter } from 'components/Catalog/PlatformFilters';

export enum GenericFilterType {
    MULTI_RANGES_WITH_ITEMS_DROPDOWN = 'MULTI_RANGES_WITH_ITEMS_DROPDOWN',
    MULTI_DROPDOWN = 'MULTI_DROPDOWN',
    INTERACTIVE_MULTI_DROPDOWN = 'INTERACTIVE_MULTI_DROPDOWN',
    SINGLE_DROPDOWN = 'SINGLE_DROPDOWN',
    SINGLE_TREE_DROPDOWN = 'SINGLE_TREE_DROPDOWN',
    MULTI_TREE_DROPDOWN = 'MULTI_TREE_DROPDOWN',
    TAGS_MULTI_DROPDOWN = 'TAGS_MULTI_DROPDOWN',
    STRATEGY_DROPDOWN = 'STRATEGY_DROPDOWN',
    RANGE_DROPDOWN = 'RANGE_DROPDOWN',
    DATE_RANGE = 'DATE_RANGE',
    BOOLEAN = 'BOOLEAN',
    CPI = 'CPI',
    COMPETITORS = 'COMPETITORS',
    MARGIN = 'MARGIN',
    GROSS_MARGIN = 'GROSS_MARGIN',
    GROSS_PROFIT = 'GROSS_PROFIT',
    MARGIN_IMPACT = 'MARGIN_IMPACT',
    REVENUE = 'REVENUE',
    VOLUME = 'VOLUME',
    RULES = 'RULES',
    GUIDELINES = 'GUIDELINES',
    CORRIDOR_STATUS = 'CORRIDOR_STATUS',
    APPROVAL_SOURCE = 'APPROVAL_SOURCE',
    PRICE_APPROVED_DATE = 'PRICE_APPROVED_DATE',
    TABLE_CONTENT = 'TABLE_CONTENT',
}

export type GenericFilters = Record<string, any>;

export interface SimpleDropdownFilterOption {
    code: string | number;
    name: string | number;
}

export interface TreeDropdownOption {
    code: string;
    name: string;
    ancestors?: { code: string; name: string }[];
    children?: TreeDropdownOption[];
}

export interface GenericFilter {
    property: string;
    label: string;
    default?: SimpleDropdownFilterOption;
    type: DefaultPlatformFilterType;
    primary?: boolean;
    // Options can be options for simple select or tree select
    options: TreeDropdownOption[] | SimpleDropdownFilterOption[];
    isClearable?: boolean;
}

export interface FiltersContextProps {
    filtersArray: PlatformFilter[] | GenericFilter[];
    updateFiltersArray: (newArray: PlatformFilter[] | GenericFilter[]) => void;
}

export const FiltersContext = createContext<FiltersContextProps>({
    filtersArray: [],
    updateFiltersArray: () => undefined,
});

// Find shared manually for now
const LegacyFiltersManager = ({ children }: { children: JSX.Element }) => {
    const [filtersArray, setFiltersArray] = useState<PlatformFilter[] | GenericFilter[]>([]);

    const updateFiltersArray = useCallback((newArray: PlatformFilter[] | GenericFilter[]) => {
        setFiltersArray(newArray);
    }, []);

    return (
        <FiltersContext.Provider
            value={{
                filtersArray,
                updateFiltersArray,
            }}
        >
            {children}
        </FiltersContext.Provider>
    );
};

export default LegacyFiltersManager;
